import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SalaryComparatorService {

    constructor(private http: HttpClient) {
    }

    createSalaryComparator(data: object) {
        return this.http.post('agri/createSalaryComparator', data);
    }

    compareSalary(id: string) {
        return this.http.get('agri/compareSalary?salaryComparatorId=' + id);
    }

    compareSalaryById(id: string) {
        return this.http.get('agri/getComparatorById?salaryComparatorId=' + id);
    }


}
